import React, { Fragment } from "react";
import PropTypes from "prop-types";
import ReactTooltip from "react-tooltip";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faInfoCircle } from "@fortawesome/free-solid-svg-icons";
import Select from "react-select";
import makeAnimated from "react-select/lib/animated";
import notificationRecipientsType from "../types/notificationRecipientsType";
import errorsType from "../types/errorsType";
import tooltips from "./tooltips";
import {
  SectionTitle,
  Field,
  Label,
  LabelText,
  LabelIcon,
  Required,
  SelectWrapper,
  Error,
} from "../styles/edit-form-styles";

const Notifications = ({
  notificationRecipients,
  notificationRecipientIds,
  notificationRecipientsOnChange,
  errors,
}) => {
  const filteredRecipients = notificationRecipients.filter((recipient) =>
    notificationRecipientIds.includes(recipient.value)
  );

  return (
    <Fragment>
      <SectionTitle>Notifications</SectionTitle>
      <Label htmlFor="job-title">
        <LabelText>
          Notification Recipients
          <Required>*</Required>
        </LabelText>
        <LabelIcon>
          <FontAwesomeIcon
            data-tip={tooltips.notificationRecipients}
            data-for="notification-recipients-tooltip"
            icon={faInfoCircle}
          />
          <ReactTooltip
            place="left"
            type="dark"
            effect="solid"
            aria-haspopup="true"
            id="notification-recipients-tooltip"
          />
        </LabelIcon>
      </Label>
      <Field>
        <SelectWrapper>
          <Select
            error={!!errors.notification_recipient_ids}
            onChange={(value) => notificationRecipientsOnChange(value)}
            className="react-select-container"
            classNamePrefix="react-select"
            closeMenuOnSelect={false}
            components={makeAnimated()}
            isMulti
            options={notificationRecipients}
            defaultValue={filteredRecipients}
            theme={(theme) => ({
              ...theme,
              borderRadius: 4,
              colors: {
                ...theme.colors,
                primary: "#f2008c",
                dangerLight: "#673490",
                primary25: "rgb(242, 0, 140, 0.25)",
                primary50: "rgb(242, 0, 140, 0.5)",
                neutral10: "#673490",
                neutral30: "#f2008c",
                neutral50: "rgb(86, 86, 86)",
                neutral80: "#fff",
              },
            })}
          />
          {errors.notification_recipient_ids && (
            <Error>{`This field ${errors.notification_recipient_ids}. Add at least one recipient.`}</Error>
          )}
        </SelectWrapper>
      </Field>
    </Fragment>
  );
};

Notifications.propTypes = {
  notificationRecipients: notificationRecipientsType.isRequired,
  notificationRecipientIds: PropTypes.arrayOf(PropTypes.number).isRequired,
  notificationRecipientsOnChange: PropTypes.func.isRequired,
  errors: errorsType.isRequired,
};

export default Notifications;
